<template>
  <Layout>

<!--    <div class="section example">-->
    <div>
<!--      <div class="container" style="max-width: 1160px; margin: 0 auto">-->
      <div >
        <div class="innovation-points">
          <div class="point">
            <div class="icon">🛠️</div>
            <h3>智能拆迁系统</h3>
            <p>无人机+BIM建模技术<br>72小时完成厂区全息扫描</p>
          </div>
          <div class="point">
            <div class="icon">💡</div>
            <h3>金属AI识别</h3>
            <p>毫米级金属分拣精度<br>回收价值提升40%</p>
          </div>
          <div class="point">
            <div class="icon">🌱</div>
            <h3>绿色拆解</h3>
            <p>全过程环保监控<br>危废处理达标率100%</p>
          </div>
        </div>
        <div class="example-container">
          <div class="am-tabs">
            <ul class="am-tabs-nav am-nav am-nav-tabs am-g">
              <li class="am-u-md-2"
                  v-for="(tab,index) in tabList"
                  :key="index"
                  @click.prevent="changeTab(index)"
                  :class="tabIndex === index ? 'am-active':''">
                <a href="#"><i :class="tab.icon"></i>{{ tab.name }}</a>
              </li>
            </ul>

            <div class="tabs">
              <div class="tab" v-for="(image,index) in list" :key="index">
                <img :src="image" alt="">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
export default {
  name: "ExampleView",
  components: {Layout},
  data() {
    return {
      tabIndex: 0,
      tabList: [
        {id: 0, name: '莘县信泽科技有限公司', icon: 'am-icon-camera'},
        {id: 1, name: '天津二七康库得曲轴有限公司', icon: 'am-icon-map-o'},
        {id: 2, name: '建滔天然气化工(重庆)有限公司', icon: 'am-icon-scribd'},
        {id: 3, name: '山东宁威新能源科技有限公司', icon: 'am-icon-odnoklassniki'},
      ],
      list: [],
    }
  },
  mounted() {
    this.findExampleByExampleType(0)
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index
      //console.log(index)
      this.findExampleByExampleType(index)
    },
   /* findExampleByExampleType(index) {

      if (index == 0) {
        this.list = [
          new URL('@/assets/zy_img/dx/dx_pm.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/dx/dx_mj.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/dx/dx_qz1.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/dx/dx_tp.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/dx/dx_ylj.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/dx/dx_mk.jpg', import.meta.url).href,
        ];
      }
      if (index == 1) {
        this.list = [
          new URL('@/assets/zy_img/jt/jt_tg.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_1.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_zg.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_2.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_px.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_3.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_4.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_5.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/jt/jt_6.jpg', import.meta.url).href,

        ];
      }
      if (index == 2) {
        this.list = [
          new URL('@/assets/zy_img/xz/dg.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/xz/fl.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/xz/gz.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/xz/lpz.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/xz/gz1.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/xz/xmm.jpg', import.meta.url).href,
        ];
      }
      if (index == 3) {
        this.list = [
          new URL('@/assets/zy_img/nw/hx.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/nw/hx2.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/nw/hx3.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/nw/tx.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/nw/slg.jpg', import.meta.url).href,
          new URL('@/assets/zy_img/nw/ry.jpg', import.meta.url).href,

        ];
      }
      if (index == 4) {
        this.list = [];
      }

    }*/
    findExampleByExampleType(index) {
      const ossBase = 'https://luanpu.oss-cn-beijing.aliyuncs.com'; // 请替换实际地址
      if (index == 0) {
        this.list = [
          `${ossBase}/xz/dg.jpg`,
          `${ossBase}/xz/fl.jpg`,
          `${ossBase}/xz/gz.jpg`,
          `${ossBase}/xz/gz1.jpg`,
          `${ossBase}/xz/ht.jpg`,
          `${ossBase}/xz/lpz.jpg`,
        ];
      }
      if (index == 1) {
        this.list = [
        `${ossBase}/dx/dx_pm.jpg`,
          `${ossBase}/dx/dx_mj.jpg`,
          `${ossBase}/dx/dx_qz1.jpg`,
          `${ossBase}/dx/dx_tp.jpg`,
          `${ossBase}/dx/dx_ylj.jpg`,
          `${ossBase}/dx/dx_mk.jpg`
        ];
      }
      if (index == 2) {
        this.list = [
          `${ossBase}/jt/jt_tg.jpg`,
          `${ossBase}/jt/jt_1.jpg`,
          `${ossBase}/jt/jt_2.jpg`,
          `${ossBase}/jt/jt_3.jpg`,
          `${ossBase}/jt/jt_4.jpg`,
          `${ossBase}/jt/jt_5.jpg`,
          `${ossBase}/jt/jt_6.jpg`,
          `${ossBase}/jt/jt_px.jpg`,
          `${ossBase}/jt/jt_zg.jpg`,

        ];
      }

      if (index == 3) {
        this.list = [
          `${ossBase}/nw/hx.jpg`,
          `${ossBase}/nw/hx2.jpg`,
          `${ossBase}/nw/hx3.jpg`,
          `${ossBase}/nw/ry.jpg`,
          `${ossBase}/nw/slg.jpg`,
          `${ossBase}/nw/tx.jpg`,
        ];
      }
      // 其他索引同理...
    }
  }
}
</script>

<style scoped>

.innovation-points {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 40px;
}

.point {
  text-align: center;
  padding: 20px;
  border-radius: 12px;
  background: #f8f9fa;
  transition: transform 0.3s ease;
}

.point:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 40px;
  margin-bottom: 15px;
}

h3 {
  color: #2d3748;
  margin: 10px 0;
}

/* 整体容器 */
.example-container {
  background: #f8fafc;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  margin: 2rem 0;
}

/* 标签导航 */
/* 修改激活状态样式 */
.am-tabs-nav li.am-active {
  background: linear-gradient(145deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.25));
  border: 2px solid rgba(59, 130, 246, 0.3);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1),
  inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.am-tabs-nav li.am-active a {
  color: #1d4ed8;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
}

.am-tabs-nav li.am-active i {
  color: #2563eb;
  filter: drop-shadow(0 1px 1px rgba(255, 255, 255, 0.3));
}

/* 新增过渡动画 */
.am-tabs-nav li {
  transition: background 0.3s ease,
  transform 0.2s cubic-bezier(0.22, 0.61, 0.36, 1),
  box-shadow 0.3s ease;
}

/* 优化悬停状态 */
.am-tabs-nav li:not(.am-active):hover {
  background: rgba(59, 130, 246, 0.05);
  transform: translateY(-1px);
}

.am-tabs-nav {
  border-bottom: none;
  margin-bottom: 2rem;
  background: linear-gradient(145deg, #f1f5f9, #ffffff);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.am-tabs-nav li {
  margin: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
}

.am-tabs-nav li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.5rem;
  color: #64748b;
  transition: all 0.3s ease;
  border: none !important;
}

.am-tabs-nav li i {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  color: #94a3b8;
  transition: color 0.3s ease;
}

/* 激活状态 */
.am-tabs-nav li.am-active {
  background: rgba(59, 130, 246, 0.1);
  transform: translateY(-2px);
}

.am-tabs-nav li.am-active a {
  color: #2563eb;
  font-weight: 600;
}

.am-tabs-nav li.am-active i {
  color: #3b82f6;
}

/* 悬停效果 */
.am-tabs-nav li:not(.am-active):hover {
  background: rgba(241, 245, 249, 0.6);
}

.am-tabs-nav li:hover a {
  color: #3b82f6;
}

/* 图片展示区 */
.tabs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
}

.tab {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.tab:hover {
  transform: translateY(-5px) scale(1.02);
}

.tab::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.4));
}

.tab img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .am-tabs-nav li {
    width: 33.33%;
    margin-bottom: 8px;
  }

  .tabs {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .example-container {
    padding: 1rem;
  }

  .am-tabs-nav li {
    width: 50%;
    padding: 0.5rem;
  }

  .tabs {
    grid-template-columns: 1fr;
  }

  .tab img {
    height: 200px;
  }
}
</style>
